import { roleHasPermission } from "@/lib/permissions-client"

type UserLike = { role?: string | null } | null | undefined

/**
 * Whether this account may run the wizard: pick stores, define actions, divide
 * the work and publish. Anyone else with access to bulk updates only reviews.
 */
export function canManageBulkUpdates(user: UserLike): boolean {
  return roleHasPermission(user?.role, "changeProject", "manage")
}
